export default __webpack_public_path__ + "static/media/MNE.fdfe807d.svg";